import React from 'react';
import { renderRich } from '../utils/richText';
type RichListProps = {
  items: string[];
  ordered?: boolean;
  className?: string;
};
export function RichList({
  items,
  ordered = false,
  className = ''
}: RichListProps) {
  const Tag = ordered ? 'ol' : 'ul';
  return <Tag className={`mb-4 ml-5 space-y-[7px] leading-relaxed text-body ${ordered ? 'list-decimal' : 'list-disc'} marker:text-muted ${className}`} data-id="element-123" data-mp="3j6qkmulks84z">
      {items.map(item => <li key={item} data-id="element-124" data-mp="1wirkky3m08i">{renderRich(item)}</li>)}
    </Tag>;
}